<template>
  <div class="mx-auto rounded py-6 px-4 bg-white border">
    <!-- hiddenDiv used to set button color of rainforest component -->
    <div
      class="text-primary-600"
      ref="hiddenDiv"
    ></div>
    <!-- Success State -->
    <portal-billing-payment-method-success v-if="collectPaymentMethodSuccess || hasSavedPaymentMethod">
      <template v-if="collectPaymentMethodSuccess">
        <div class="text-primary-600 font-bold text-xl mb-3">Thank you</div>
        <div class="text-gray-700 text-sm">We have notified your accountant</div>
      </template>
      <template v-if="hasSavedPaymentMethod">
        <div class="text-primary-600 font-bold text-xl mb-3">All Set</div>
        <div class="text-gray-700 text-sm">You're all set! A payment method has already been saved</div>
      </template>
    </portal-billing-payment-method-success>
    <!-- Loading State -->
    <div
      v-else-if="paymentMethodRequestLoading"
      class="flex justify-center items-center p-5"
    >
      <client-loading-indicator class="text-primary-500 fill-gray-100 w-5 h-5" />
    </div>
    <!-- Payment Form -->
    <div v-else>
      <!-- Header -->
      <div class="w-full flex flex-col">
        <div class="font-bold text-sm">Update your payment information</div>
        <div class="text-gray-400 text-sm">{{ paymentRequestData.client.name }}</div>
      </div>

      <!-- Payment Form -->
      <div
        v-if="!paymentMethodRequestLoading"
        class="w-full mt-3"
      >
        <portal-rainforest-method-request-form
          v-if="paymentRequestData.provider === 'rainforest'"
          :payment-request-data="paymentRequestData"
          @approve="collectPaymentMethodSuccess = true"
          :color="primaryColor"
        />

        <portal-stripe-method-request-form
          v-else-if="paymentRequestData.provider === 'stripe'"
          :payment-request-data="paymentRequestData"
          @approve="collectPaymentMethodSuccess = true"
          :color="primaryColor"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ClientLoadingIndicator from "../../../ClientPortal/client_auth/components/client-loading-indicator.vue"
import PortalBillingPaymentMethodSuccess from "./PortalBillingPaymentMethodSuccess.vue"
import PortalRainforestPaymentMethodForm from "../../../ClientPortal/components/invoice_payment/PortalRainforestPaymentMethodForm.vue"
import paymentMethodRequest from "../../repository/paymentMethodRequest"
import PortalRainforestMethodRequestForm from "./PortalRainforestMethodRequestForm.vue"
import PortalStripeMethodRequestForm from "./PortalStripeMethodRequestForm.vue"

export default {
  name: "PortalBillingCollectPaymentMethodCard",

  components: {
    PortalStripeMethodRequestForm,
    PortalRainforestMethodRequestForm,
    PortalRainforestPaymentMethodForm,
    PortalBillingPaymentMethodSuccess,
    ClientLoadingIndicator,
  },

  data() {
    return {
      paymentMethodRequestLoading: true,
      collectPaymentMethodSuccess: false,
      company: window.FinancialCents.company || null,
      paymentRequestData: null,
      hasSavedPaymentMethod: false,
    }
  },

  computed: {
    companyName() {
      return this.company?.name
    },

    primaryColor() {
      if (!this.$refs.hiddenDiv) {
        return null
      } // Add a guard clause
      const computedStyle = window.getComputedStyle(this.$refs.hiddenDiv)
      return computedStyle.color
    },
  },

  mounted() {
    this.loadRequest()
  },

  methods: {
    async loadRequest() {
      try {
        const params = this.$route.params
        const { data } = await paymentMethodRequest.show(params)
        this.paymentRequestData = data.data
        this.hasSavedPaymentMethod = data.data.payment_method_request.completed_at !== null
      } catch (e) {
        console.error(e)
      } finally {
        this.paymentMethodRequestLoading = false
      }
    },
  },
}
</script>
